
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import isObject$1 from './is-object.js';
import classofRaw from './classof-raw.js';
import wellKnownSymbol$1 from './well-known-symbol.js';

var isObject = isObject$1;
var classof = classofRaw;
var wellKnownSymbol = wellKnownSymbol$1;

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};

export { isRegexp as default };
//# sourceMappingURL=is-regexp.js.map
